var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://wa.me/5511949745230","target":"_blank","id":"whatsapp"}},[_c('img',{attrs:{"src":require('@images/whatsHeader.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }